(function(doc, win) {
    var docEl = doc.documentElement
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    var recalc = function() {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return
      const size = (clientWidth < 1920 ? clientWidth : 1920) / 19.2
      // const size = clientWidth / 19.2
   
      docEl.style.fontSize = size + 'px'
    }
    if (!doc.addEventListener) return
    recalc()
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  })(document, window)